import { createFileRoute } from '@tanstack/react-router'
import { requireSection } from '../../../features/settings/guards'
import { NotificationsSection } from '../../../features/settings/notifications-section'

export const Route = createFileRoute('/_app/settings/notifications')({
  staticData: { crumb: 'settingsSection' },
  beforeLoad: ({ context }) => requireSection(context.session, 'notifications'),
  component: NotificationsSection,
})
